import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'

// 레슨 학습기록(최초 학습 헤더 + 복습 회차). lessonId null 이면 비활성(모달 닫힘 상태).
// 완료된 레슨만 조회 가능(미완료는 BE 가 LESSON_NOT_COMPLETED) — 호출부에서 게이팅한다.
export function useLessonDetail(
  learnerId: number,
  lessonId: number | null,
  courseId: number | undefined,
  moduleId: number | undefined,
) {
  return useQuery({
    queryKey: coachingKeys.lessonDetail(learnerId, lessonId ?? 0, courseId ?? 0, moduleId ?? 0),
    queryFn: () => {
      if (lessonId == null || courseId == null || moduleId == null) {
        throw new Error('Lesson detail requires a complete content path')
      }
      return lcCoachingApi.getLessonDetail(learnerId, lessonId, courseId, moduleId)
    },
    enabled:
      Number.isFinite(learnerId) && learnerId > 0 &&
      lessonId != null && Number.isFinite(lessonId) && lessonId > 0 &&
      courseId != null && Number.isFinite(courseId) && courseId > 0 &&
      moduleId != null && Number.isFinite(moduleId) && moduleId > 0,
    staleTime: 30_000,
  })
}
